import {
  Box,
  Button,
  Collapse,
  ExpandMoreRoundedIcon,
  FilterListOutlinedIcon,
  Flex,
  Rotate,
  SearchInput,
} from '@shared/components';
import { useDisclosure } from '@shared/hooks';

import { useProctorRequestListSearchParams } from '../../hooks';
import { ProctorRequestListFilterForm } from '../proctor-request-list-filter-form';

export default function ProctorRequestListFilterSection() {
  const [{ search }, { changeSearch }] = useProctorRequestListSearchParams();
  const [isExpand, { toggle }] = useDisclosure(false);

  const handleSearchInputChange = (value: string) => {
    changeSearch(value);
  };

  return (
    <>
      <Flex sx={{ justifyContent: 'space-between' }}>
        <Box sx={{ width: 300 }}>
          <SearchInput
            placeholder='ค้นหาชื่อผู้คุมสอบ...'
            defaultValue={search}
            onChange={handleSearchInputChange}
          />
        </Box>
        <Button
          variant='outlined'
          color='secondary'
          size='large'
          startIcon={<FilterListOutlinedIcon />}
          endIcon={
            <Rotate in={isExpand}>
              <ExpandMoreRoundedIcon />
            </Rotate>
          }
          onClick={toggle}
        >
          Filter
        </Button>
      </Flex>
      <Collapse in={isExpand} unmountOnExit>
        <ProctorRequestListFilterForm />
      </Collapse>
    </>
  );
}
